import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

import { ref, watchEffect } from "vue";

import { getClasses } from "~/js/composables/classes";
import { Consent } from "~/js/interfaces/consent-types";
import { Translations } from "~/js/interfaces/translations";
import { openConsentSettings } from "~/js/utils/cookie-script";

import CardConsent from "~/vue/molecules/cards/CardFileManagerConsent.vue";
import PopupConsent from "~/vue/organisms/popups/PopupConsent.vue";

interface Props {
	consents: Array<Consent>;
	translations?: Translations | null;
	activeConsentId?: string;
	utilities?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GridFileManagerConsent',
  props: {
    consents: {},
    translations: { default: null },
    activeConsentId: { default: null },
    utilities: { default: "" }
  },
  emits: ["consent-given", "consent-declined"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const classes = ref({
	wrapper: {
		grid: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
		spacing: "gap-6",
		utilities: props.utilities,
	},
});

const activeConsent = ref(null);
const emit = __emit;

const onShowConsent = (id: string) => {
	activeConsent.value = props.consents.find((consent: Consent) => consent.id === id);
	console.log("On show consent: ");
	console.log(activeConsent.value);
};

const onConsentGiven = (id: string) => {
	const filter = props.consents.find((consent: Consent) => consent.id === id)?.filter;
	console.log("On consent given: ");
	console.log(filter);
	emit("consent-given", filter);
};

const onDeclinedConsent = () => {
	activeConsent.value = null;
	console.log("On consent declined: ");
	console.log(activeConsent.value);
	emit("consent-declined");
};

const onAcceptConsent = (consent: Consent) => {
	console.log("On consent accepted: ");
	console.log(activeConsent.value);
	openConsentSettings();
	activeConsent.value = null;
	onConsentGiven(consent.id);
};

watchEffect(() => {
	if (props.activeConsentId) {
		console.log("Props active consent id: ");
		console.log(props.activeConsentId);
		activeConsent.value = props.consents.find((consent: Consent) => consent.id === props.activeConsentId);
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(getClasses)(classes.value, 'wrapper'))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.consents, (consent) => {
      return (_openBlock(), _createBlock(CardConsent, {
        id: consent.id,
        key: consent.id,
        "date-updated": consent.dateUpdated,
        heading: consent.filter.heading,
        description: consent.filter.description,
        onShowConsent: _cache[0] || (_cache[0] = (id) => onShowConsent(id)),
        onBypass: _cache[1] || (_cache[1] = (id) => onConsentGiven(id))
      }, null, 8, ["id", "date-updated", "heading", "description"]))
    }), 128)),
    _createVNode(_Transition, {
      "enter-active-class": "duration-200 ease-out",
      "enter-from-class": "transform opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "duration-100 ease-in",
      "leave-from-class": "opacity-100",
      "leave-to-class": "transform opacity-0"
    }, {
      default: _withCtx(() => [
        (activeConsent.value)
          ? (_openBlock(), _createBlock(PopupConsent, {
              key: 0,
              consent: activeConsent.value,
              onDecline: onDeclinedConsent,
              onAccept: _cache[2] || (_cache[2] = (consent) => onAcceptConsent(consent))
            }, null, 8, ["consent"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}
}

})